import React, { Component } from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppButton() {
  const phoneNumber = '919876543210'; // Mock number
  const message = encodeURIComponent('Hi, I am interested in ordering from Sky Brand!');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300" aria-label="Chat on WhatsApp" data-id="element-409">
      <MessageCircleIcon className="w-8 h-8" data-id="element-410" />
    </a>;
}